import React, { useState } from "react";
import AvensysLogo2 from "@workspace/main/src/assets/images/Avensys Logo 2.png";
import AssessementCard from "./AssessementCard";
import { ASSESSMENT_TYPE } from "../portalAssessmentConstant";

const AssessmentSelection = ({ handleAssessmentSelected, assessmentType }) => {
  return (
    <div
      style={{
        backgroundColor: "#F6F6F6",
      }}
    >
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "12.5vh",
          backgroundColor: "#FFFFFF",
        }}
      >
        <div>
          <img src={AvensysLogo2} alt="Avensys Logo" />
        </div>
      </div>
      <div
        className="d-flex justify-content-center align-items-center"
        style={{
          height: "87.5vh",
        }}
      >
        <div
          style={{
            width: "55%",
          }}
        >
          <h2 className="text-center">
            Choose the method you enjoy most or feel happiest with to prepare
            for the pre-assignment interview.
          </h2>
          <div className="d-flex gap-3 mt-4">
            {ASSESSMENT_TYPE.map((assessment, index) => (
              <div
                className="cursor-pointer"
                onClick={(e) => {
                    e.stopPropagation();
                    handleAssessmentSelected(assessment)}}
                // style={{
                //   border:
                //     assessmentType &&
                //     assessment?.title == assessmentType?.title &&
                //     "1px solid #E5E5E5",
                // }}
              >
                <AssessementCard
                  key={index}
                  title={assessment?.title}
                  description={assessment?.description}
                  iconImg={assessment?.iconImg}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AssessmentSelection;
